// ApiContext.tsx
import React, {createContext, ReactNode, useCallback, useEffect, useMemo, useRef, useState,} from "react";
import {ApiContextType, ParentData} from "./types";
import {KeyExchangeApi} from "./Apiservices";
import {apiServiceHeadersConfig} from "../constants/config";

const ApiContext = createContext<ApiContextType | undefined>(undefined);

interface ApiProviderProps {
    children: ReactNode;
}

export const KeyExchangeApiProvider: React.FC<ApiProviderProps> = ({
                                                                       children,
                                                                   }) => {

    const [parentData, setParentData] = useState<ParentData | null>(null);
    const [isSecureChannelEnabled, setIsSecureChannelEnabled] =
        useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const initialized = useRef(false);

    const fetchParentData = useCallback(async () => {
        try {
            setLoading(true);
            const response  = await KeyExchangeApi();

            const symmetricKey = response[0].headers[apiServiceHeadersConfig.symmetricKey];

            if (response[0].status === 200 && (symmetricKey === undefined ||
            symmetricKey === null) ) {
                setIsSecureChannelEnabled(false);
            }

            if (response[0] !== undefined) {
                setParentData(response[0].data);
                setIsSecureChannelEnabled(true);

                return;
            } else {
                setError("Error fetching Session key");
            }
        } catch (err: any) {
            console.error("Error fetching parent data", err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!initialized.current) {
            fetchParentData();
            initialized.current = true;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return useMemo(
        () => (
            <ApiContext.Provider
                value={{parentData, loading, error, isSecureChannelEnabled}}
            >
                {children}
            </ApiContext.Provider>
        ),
        [parentData, loading, error] // eslint-disable-line react-hooks/exhaustive-deps
    );
};

export default ApiContext;
